import { unstable_rethrow } from 'next/navigation';

/**
 * Re-throws Next.js control-flow errors (redirect, notFound, forbidden, unauthorized)
 * so catch blocks don't accidentally suppress them.
 *
 * Call as the first statement in every catch block inside Server Components and Server Actions.
 */
export function rethrowNextErrors(error: unknown): void {
  unstable_rethrow(error);
}
